import { memo } from 'react'
import { Stack } from '@mui/material'
import { faCopy } from '@fortawesome/pro-duotone-svg-icons'

import { toast } from 'src/components/shared/snackbar'
import SubmitButton from '../shared/button/SubmitButton'
import Text from '../shared/text/Text'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import { copyToClipBoard } from '../../util/app/app.helpers'

const AccountNumberText = ({ authId }) => (
  <Text
    variant='caption'
    sx={{ color: 'text.disabled', wordBreak: 'break-word' }}
    label={authId}
  />
)

const AccountNumberContent = ({ authId, t, iconAction }) => {
  const handleCopy = async () => {
    await copyToClipBoard(authId)
    toast.success(t('message.account-number-copied'))
  }

  if (iconAction) {
    return (
      <Stack direction='row' alignItems='center' spacing={0.5} px={2.5}>
        <AccountNumberText authId={authId} />
        <SubmitButton
          type='button'
          size='default'
          onClick={handleCopy}
          label={<FaIcon icon={faCopy} fontSize={20} />}
          sx={{ minWidth: 32, height: 40 }}
        />
      </Stack>
    )
  }

  return (
    <>
      <AccountNumberText authId={authId} />
      <Stack alignItems='center'>
        <SubmitButton
          type='button'
          sx={{ mt: 3 }}
          size='default'
          label={t('user-account.copy-number')}
          onClick={handleCopy}
        />
      </Stack>
    </>
  )
}

export default memo(AccountNumberContent)
